import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getSiteInfo } from "../services/apiService";
import { API_BASE_URL } from "../config/api";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [siteInfo, setSiteInfo] = useState({});

  useEffect(() => {
    const fetchSiteInfo = async () => {
      try {
        const response = await getSiteInfo();
        const data = response?.data || response;

        // Convert array of {type, value} to object
        const infoObj = {};
        if (Array.isArray(data)) {
          data.forEach((item) => {
            infoObj[item.type] = item.value;
          });
        }
        setSiteInfo(infoObj);
      } catch (error) {
        console.error("Error fetching site info:", error);
      }
    };

    fetchSiteInfo();
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);

    // body overflow toggle
    if (window.innerWidth < 768) {
      document.body.classList.toggle("overflow-hidden", !menuOpen);
    } else {
      document.body.classList.toggle("overflow-hidden", !menuOpen);
      document.body.classList.toggle("me-10px", !menuOpen);
    }
  };

  return (
    <header>
      <div className="menuSection">
        <div className="container-fluid add-padding">
          <div className="row">
            {/* Logo */}
            <div className="col-lg-3 col-md-2 col-sm-4 col-6">
              <div className="header-logo">
                <Link to="/">
                  <img
                    src={
                      siteInfo.header_logo
                        ? `${API_BASE_URL}/uploads/site-settings/${siteInfo.header_logo.replace(
                            "/uploads/",
                            ""
                          )}`
                        : "/images/logo.png"
                    }
                    alt={siteInfo.site_name || "The Design Showroom by LUXE"}
                  />
                </Link>
                <p>All your lifestyle needs under one roof</p>
              </div>
            </div>

            {/* Desktop Menu */}
            <div className="col-lg-6 col-md-8 d-none d-md-block">
              <div className="menuSec">
                <ul id="menu">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/livegallery">Live Gallery</Link>
                  </li>
                  <li>
                    <Link to="/services">Services</Link>
                  </li>
                  <li>
                    <Link to="/projects">Gallery</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact Us</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Enquire Button */}
            <div className="col-lg-3 col-md-2 col-sm-4 col-12 order-sm-2 order-3 text-right">
              <div className="header_btn">
                <Link to="/enquire" className="theme-btn-1">
                  <span>Enquire Now</span>
                </Link>
              </div>
            </div>

            {/* Mobile Menu Button */}
            <div className="col-sm-4 col-6 text-right d-block d-md-none">
              <div className="mobile-menu">
                <ul id="menu">
                  <li>
                    <button
                      className={`menu-btn ${menuOpen ? "active" : ""}`}
                      id="menu-btn"
                      onClick={toggleMenu}
                    >
                      <svg
                        viewBox="0 0 45 43"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          className={`path1 ${menuOpen ? "cross" : ""}`}
                          d="M1.5 7L27.5 33C27.5 33 30.5 36 36.5 40.5C42.5 45 48 33.5 41.5 33C35 32.5 2 33 2 33"
                          stroke="black"
                          strokeWidth="2"
                        />
                        <path
                          className={`path2 ${menuOpen ? "cross" : ""}`}
                          d="M2 33L28 7C28 7 33.5 1 37 1C40.5 1 43 6.20692 40 7C37 7.79308 1 7 1 7"
                          stroke="black"
                          strokeWidth="2"
                        />
                        <path
                          className={`mline ${menuOpen ? "hide" : ""}`}
                          d="M1.5 20H28.5"
                          stroke="black"
                          strokeWidth="2"
                        />
                      </svg>
                    </button>

                    {/* Mobile Menu Overlay */}
                    <div
                      className={`menu-box ${menuOpen ? "active" : ""}`}
                      id="menu-box"
                    >
                      <nav>
                        <Link to="/" onClick={toggleMenu}>
                          Home
                        </Link>
                        <Link to="/about" onClick={toggleMenu}>
                          About Us
                        </Link>
                         <Link to="/livegallery" onClick={toggleMenu}>
                          Live Gallery
                        </Link>
                        <Link to="/services" onClick={toggleMenu}>
                          Services
                        </Link>
                        <Link to="/projects" onClick={toggleMenu}>
                          Gallery
                        </Link>
                        <Link to="/contact" onClick={toggleMenu}>
                          Contact Us
                        </Link>
                      </nav>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
